import React, { useState } from 'react';
import { TextField } from 'components/TextField/TextField';
import { TextFieldProps } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton } from '../IconButton/IconButton';
import { InputAdornment } from '../InputAdornment/InputAdornment';

type SecureTextFieldProps = TextFieldProps & {
  id: string;
};

export const SecureTextField = (props: SecureTextFieldProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickVisibilityToggle = () => setShowPassword((show) => !show);
  const textFieldType = showPassword ? 'text' : 'password';
  const visibilityIcon = showPassword ? <VisibilityOff /> : <Visibility />;

  return (
    <TextField
      {...props}
      type={textFieldType}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickVisibilityToggle}
                edge="end"
              >
                {visibilityIcon}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
